import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { topics } from "@/mocks/topics";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto grid grid-cols-1 gap-10 px-4 py-12 md:grid-cols-4 md:px-6 md:py-16">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-eye-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950">
              {siteInfo.name}
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
            {siteInfo.slogan}。我们只处理公开可核查的物料，把评分口径、评委关系与计分流程摊开来看，让赛果争议有据可循。
          </p>
          <p className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
            <a href={`mailto:${siteInfo.email}`} className="hover:text-primary-600">
              {siteInfo.email}
            </a>
          </p>
        </div>

        <nav aria-label="页面导航">
          <h4 className="font-heading text-base font-semibold text-foreground-950">浏览</h4>
          <ul className="mt-4 space-y-3 text-sm text-foreground-700">
            <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
            <li><Link to="/topics" className="hover:text-primary-600">爆料专题</Link></li>
            <li><Link to="/faq" className="hover:text-primary-600">常见问题</Link></li>
            <li><Link to="/about" className="hover:text-primary-600">关于我们</Link></li>
            <li><Link to="/about#contact" className="hover:text-primary-600">投递线索</Link></li>
          </ul>
        </nav>

        <nav aria-label="专题导航">
          <h4 className="font-heading text-base font-semibold text-foreground-950">专题</h4>
          <ul className="mt-4 space-y-3 text-sm text-foreground-700">
            {topics.map((topic) => (
              <li key={topic.id}>
                <Link to={`/topics?topic=${topic.id}`} className="hover:text-primary-600">
                  {topic.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-secondary-200">
        <div className="mx-auto flex flex-col items-start justify-between gap-3 px-4 py-6 text-xs text-foreground-600 sm:flex-row sm:items-center md:px-6">
          <p>© {year} {siteInfo.name} · 内容仅供讨论与复盘参考</p>
          <p>文中涉及线索均来自公开物料，欢迎勘误与补充</p>
        </div>
      </div>
    </footer>
  );
}